module.exports = __webpack_public_path__ + "static/media/user-ninja.6ec2f5a1.svg";